import { translate } from "../translations/index.ts";
import { useNavigate, Link } from "react-router";
import pencilIllustration from "../images/pencil.png";
import lightbulbsIllustration from "../images/lightbulbs.png";
import APIclient from "../api-client";

export default function Home() {
  const navigate = useNavigate();
  const titleWords = translate("homePage.title").split(" ");

  async function startDefaultGame(event) {
    event.preventDefault();
    const data = await APIclient.sessions.create("__DEFAULT_GAME__");
    navigate(`/teacher/votingsession/${data.code}`);
  }

  return (
    <>
      <form className="page__container" onSubmit={startDefaultGame}>
        <img
          src={lightbulbsIllustration}
          alt=""
          className="page__illustration"
        />
        <h1 className="page__title" id="startTitle">
          {titleWords.slice(0, -1).join(" ")}&nbsp;
          <span className="--highlighted">{titleWords.at(-1)}</span>
        </h1>
        <p className="page__text">{translate("homePage.intro")}</p>
        <div className="button-group">
          <button className="button button--xl">
            {translate("homePage.startDefaultGame")}
          </button>
          <Link
            className="button button--outline button--xl"
            to="/teacher/games/new"
          >
            {translate("homePage.createGame")}
          </Link>
        </div>
      </form>
      <div className="page__section page__section--accent">
        <img src={pencilIllustration} alt="" className="page__decoration" />
      </div>
    </>
  );
}
